import { Dialog, useMediaQuery } from '@buffer-mono/popcorn'

import { useModalManager } from '../../../ModalManager/hooks/useModalManager'

import SwitchFromIGLoginToFBLogin from '../../../../exports/Orchestrator/channelConnections/components/SwitchFromIGLoginToFBLogin/SwitchFromIGLoginToFBLogin'

import type { JSX } from 'react'

export function SwitchFromIGLoginToFBLoginDialog(): JSX.Element {
  const { modalData: data, dismissModal: closeAction } = useModalManager()
  const isMobile = useMediaQuery('(width < 641px)')
  const dialogSize = isMobile ? 'maximize' : 'xlarge'

  return (
    <Dialog
      open
      onOpenChange={(): void => {
        // custom close action
        if (data?.onCustomCloseAction) {
          data.onCustomCloseAction()
        }

        // default close action to dismiss modal
        closeAction()
      }}
    >
      <Dialog.Content size={dialogSize}>
        <SwitchFromIGLoginToFBLogin channelId={data?.channelId || ''} />
      </Dialog.Content>
    </Dialog>
  )
}
